<!--
 * @Author: zb
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:56
 * @LastEditTime: 2019-08-28 18:46:46
 * @Version: 1.0
 * @Description: 个人中心货源管理的货源列表页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div class="content-container">
    <div class="goods-head">
      <div class="slider-list" @click="toggleState($event)">
        <div :class="{ 'selected': state == 0}" :data-value="0" class="item">待发布</div>
        <div :class="{ 'selected': state == 1}" :data-value="1" class="item">已发布</div>
        <div :class="{ 'selected': state == 2}" :data-value="2" class="item">已成交</div>
      </div>
      <!-- 查询表单  -->
      <div class="goods-head-form">
        <div class="fileds">
          <el-form ref="form" :inline="true" :model="queryParams" label-width="100px" :rules="rules">
            <el-form-item label="始发地" prop="startPlace">
              <el-cascader
                v-model="queryParams.startPlace"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
                @expand-change="expandChange"
              />
            </el-form-item>
            <el-form-item label="目的地" prop="stopPlace">
              <el-cascader
                v-model="queryParams.stopPlace"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
                @expand-change="expandChange"
              />
            </el-form-item>
            <el-form-item label="货物类型" prop="goodsType">
              <el-select v-model="queryParams.goodsType" placeholder="请选择">
                <el-option
                  v-for="(item,index) in goodsType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-inputFilter label="货物名称" prop="goodsName">
              <el-input v-model="queryParams.goodsName" class="goods-name" placeholder="请输入" />
            </el-form-item>
          </el-form>
        </div>
        <div class="buttons">
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="loadData"
          >
            <i class="el-icon-search" />查询
          </el-button>
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="resetForm"
          >
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
    </div>
    <!--存入表格数据-->
    <article class="operations">
      <template v-if="state == 0">
        <el-button
          size="small"
          class="form-item-btn"
          type="primary"
          style="background-color: #BE2316;border-color: #F56C6C;"
          @click="batchPublishGoods"
        >
          <i class="el-icon-plus" />批量发布
        </el-button>
        <el-button
          size="small "
          class="form-item-btn"
          type="primary"
          style="background-color: #BE2316;border-color: #F56C6C;"
          @click="batchDel"
        >
          <i class="el-icon-delete-solid" />批量删除
        </el-button>
      </template>
    </article>

    <div v-loading="viewManager.loading" class="goods-data">
      <div class="goods-data-header">
        <ul>
          <template v-if="state != 2">
            <li class="check">
              <el-checkbox v-model="allSelection" @change="selection()" />
            </li>
          </template>
          <li :class="{'publish': state == 2}">起始地/目的地</li>
          <li>货物名称</li>
          <li>{{ state == 0 ? '创建' : '发布' }}时间</li>
          <li v-if="state == 2">成交时间</li>
          <template v-if="state == 1">
            <li>总价</li>
            <li>单价</li>
            <li>邀请数量</li>
            <li>报价次数</li>
          </template>
          <li>操作</li>
        </ul>
      </div>
      <div ref="data-body" class="goods-data-body">
        <template v-if="data.length < 1 && !viewManager.loading">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(item , index) of data">
          <div :key="index" class="data-item">
            <ul>
              <template v-if="state != 2">
                <li class="check">
                  <div class="vertical-align">
                    <el-checkbox v-model="item.selection" @change="change()" />
                  </div>
                </li>
              </template>
              <li :class="{'publish': state == 2}">
                <div class="vertical-align">{{ item.startPlaceLabel }}一{{ item.stopPlaceLabel }}</div>
              </li>
              <li>
                <div class="vertical-align">{{ item.goodsTypeLabel }}ᅳ{{ item.goodsName }}</div>
              </li>
              <li>
                <div class="vertical-align">{{ item.createDate | _data }}</div>
              </li>
              <template v-if="state == 1">
                <li>
                  <div class="vertical-align">{{ item.expectPrice }} 元</div>
                </li>
                <li>
                  <div class="vertical-align">{{ item.singlePrice }} 元/吨公里</div>
                </li>
                <li>
                  <div class="vertical-align">
                    <a
                      href="javascript:void(0)"
                      @click="popInvitationList(item.id)"
                    >{{ item.numberInvitation }}</a>
                  </div>
                </li>
                <li>
                  <div class="vertical-align">
                    <a href="javascript:void 0" @click="popBidList(item)">{{ item.numberQuotation }}</a>
                  </div>
                </li>
              </template>
              <li v-if="state == 2" :class="{'publish': state == 2}">
                <div class="vertical-align">{{ item.dealTime }}</div>
              </li>
              <li v-if="state == 2">
                <el-button plain size="small" @click="showDetail(item, index,$event)">
                  详情
                  <i :class="{'expand': !item.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
              <li v-if="state != 2">
                <template v-if="state == 1">
                  <el-button type="text" @click="popRecommendList(item)">运力推荐</el-button>
                  <el-divider direction="vertical" />
                </template>
                <template v-if="state == 0">
                  <el-button type="text" @click="edit(item.id)">编辑</el-button>
                  <el-divider direction="vertical" />
                  <el-button type="text" @click="del(item.id)">删除</el-button>
                  <el-button type="text" @click="publishGoods(item)">发布</el-button>
                  <!-- <el-divider direction="vertical" /> -->
                </template>
                <template v-if="state == 1">
                  <el-button type="text" @click="revoke(item)">取消发布</el-button>
                </template>
                <el-button plain size="small" @click="showDetail(item, index,$event)">
                  详情
                  <i :class="{'expand': !item.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <goodsFullInfo v-if="!item.hidden" :goods="item" :area="area" />
          </div>
        </template>
      </div>
      <div class="goods-data-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </div>
    </div>
    <!-- 展示货源邀请详情 -->
    <goods-invitation ref="goodsInvitation" />

    <!-- 展示报价运力,   -->
    <offerDialog ref="offerDialog" @transaction-done="loadData" />
    <!--  运力推荐  -->
    <recommendDialog ref="transport-recommend" @close="loadData" />
  </div>
</template>

<script>
import mixinsFunction from '@/utils/mixinsFunction'
import goodsFullInfo from '../components/goodsFullInfo'
import offerDialog from './offerDialog'
import {
  getPageList,
  del,
  batchDel,
  batchIssue,
  goodsListData,
  revoke,
  invitationBid
} from '@/api/personal/find/goodsManager'
import recommendDialog from './recommendDialog'
import { Page } from '@/utils/commonDataModel'
import goodsInvitation from '@/views/personal/goods/components/goodsInvitation'
import { requiredRules } from '../dataConfig/index'

const requiredItems = () => {
  const keys = []
  for (const key in requiredRules) {
    if (requiredRules[key].some(item => item.required)) {
      keys.push(key)
    }
  }
  return keys
}

const validateData = (item) => {
  for (const key in item) {
    if (requiredItems().some(i => i === key)) {
      if (!item[key]) {
        return { state: false, key: key }
      } else if (typeof item[key] === 'string' && item[key] === '') {
        return { state: false, key: key }
      } else if (Object.prototype.toString.call(item[key]) === 'Array' && item[key].length == 0) {
        return { state: false, key: key }
      }
    }
  }
}

const rules = {
  goodsName: [
    { max: 50, message: '长度最大 50 个字符', trigger: 'blur' }
  ]
}

const State = {
  TRANSACTED: 2, // 已成交
  PUBLISH: 1, // 已报价
  UNPUBLISH: 0 // 未报价
}

export default {
  name: 'GoodsList',
  components: {
    goodsFullInfo,
    offerDialog,
    recommendDialog,
    'goods-invitation': goodsInvitation
  },
  mixins: [mixinsFunction],
  data: function() {
    return {
      rules: rules,
      // 选中的货源
      goods: '',
      data: [],
      allSelection: false,
      showMore: false,
      // 表格数据
      pagination: new Page(),
      queryParams: {},
      state: State.UNPUBLISH, // 初始未发布状态
      area: [],
      // 运输方式
      transportType: [],
      goodsType: []
    }
  },
  watch: {
    state: function() {
      if (this.$route.params.data) {
        return
      } else {
        this.cleanModal(this.queryParams)
        this.loadData()
      }
    }
  },
  created: function() {
    // 获取从消息通知过来的数据
    if (this.$route.params.noticeId != undefined) {
      this.state = 1 // 跳转已发布的tab页
      const id = {
        id: this.$route.params.data.noticeModuleId
      }
      getPageList(this.pagination, id)
        .then(data => {
          if (data.result.rows && data.result.rows.length > 0) {
            this.data = data.result.rows.map(item => {
              if (!item.hasOwnProperty('hidden')) {
                item.hidden = true
              }
              if (!item.hasOwnProperty('selection')) {
                item.selection = false
              }
              if (item.fileUrl !== '') {
                item.fileUrl = String(item.fileUrl).split(',')
              }
              return item
            })
          }
          this.pagination.total = data.result.total || this.data.length
          // console.log(data.result.rows[0])
          this.popBidList(data.result.rows[0])
        })
        .catch(error => {
          this.data = goodsListData.map(item => {
            if (!item.hasOwnProperty('hidden')) {
              item.hidden = true
            }
            return item
          })
          this.pagination.total = this.data.length
          console.error(error)
        })
        .finally(() => {
          // 数据刷新时  全选状态为false
          this.allSelection = false
          this.scrollTop()
          this.viewManager.loading = false
        })
      // console.log('消息通知过来的数据', 'noticeId:' + this.$route.params.noticeId, 'noticeMark:' + this.$route.params.noticeMark)
    } else {
      this.init()
    }
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.loadData()
      }
    }
  },
  methods: {
    // 初始化函数
    async init() {
      await Promise.all([
        this.getArea(),
        this.getGoodsType(),
        this.getTransportType(),
        this.loadData()
      ]).then(data => {
        [this.area, this.goodsType, this.transportType] = data
      })
      this.viewManager.loading = false
    },
    // 展示详情
    showDetail(goods, index, event) {
      // 当前是展开的只需关闭
      if (goods.hidden) {
        // 把展开的关闭
        this.data.forEach((item, position) => {
          // 要关闭的元素
          if (!item.hidden) {
            const lastState = event.target.getBoundingClientRect()
            item.hidden = true
            // 如果当前元素比要展开的元素在前面， 需要向上滚动
            if (position < index) {
              setTimeout(() => {
                this.computePositionScroll(event.target, lastState)
              }, 50)
            }
          }
        })
      }
      goods.hidden = !goods.hidden
    },
    // 打开运力推荐
    popRecommendList(goods) {
      this.$refs['transport-recommend'].open(goods)
    },
    // 切换发布状态
    toggleState(event) {
      if (!event.target.classList.contains('slider-list')) {
        if (event.target.dataset) {
          this.state = event.target.dataset.value
        } else {
          this.state = event.target.getAttribute('data-value')
        }
      }
    },
    // 邀请报价
    invitationBid(item) {
      var param = {}
      param.id = item.id
      invitationBid(param)
        .then(data => {
          if (data.result === 1) {
            item.id = 1
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    refuseBid(id) {
      console.log(id)
    },
    agreeInvitation(id) {
      console.log(id)
    },
    refuseInvitation(id) {
      console.log(id)
    },
    // 展示相应的货源的邀请运力列表
    popInvitationList(goodsId) {
      // 根据id查询出对应列表
      this.$refs['goodsInvitation'].open(goodsId)
    },
    popBidList(goods) {
      console.log(goods)
      // 根据id查询出对应列表
      this.$refs['offerDialog'].open(goods)
    },
    // 重置表单并刷新
    resetForm() {
      this.cleanModal(this.queryParams)
      // this.$refs['form'].resetFields()
      this.loadData()
    },
    // 回到表格顶部
    scrollTop() {
      window.scrollTo(0, 0)
      // this.$refs['header'].scrollIntoView()
    },
    // 子项选择
    change(index) {
      // this.data[index].selection = !this.data[index].selection
      this.allSelection = this.data.every(i => i.selection)
    },
    // 全选
    selection() {
      this.data.forEach(i => {
        if (i.selection !== this.allSelection) {
          i.selection = !i.selection
        }
      })
    },
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    },
    invitedDetails() {
      this.$refs['invitedDetails'].open(arguments[0])
    },
    // 批量删除货源
    batchDel() {
      const ids = this.data.filter(item => item.selection).map(item => item.id)
      if (ids == '') {
        this.$message({
          type: 'warning',
          message: '请选择要删除的数据!'
        })
        return
      } else {
        this.$confirm('此操作将删除选中数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            if (ids.length > 0) {
              batchDel({ ids: ids.toString() })
                .then(data => {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                  this.loadData()
                })
                .catch(error => {
                  console.error(error)
                })
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      }
    },
    // 转换参数
    exchangeData(data) {
      const handle = {
        get(target, key, proxy) {
          if (
            (key == 'startPlace' || key === 'stopPlace') &&
            target[key] &&
            target[key].length > 0
          ) {
            return target[key] instanceof Object
              ? target[key].length === 1
                ? target[key].join('#')
                : target[key].join('#') + '#'
              : target[key]
          } else {
            return target[key]
          }
        }
      }
      if (window && window.Proxy) {
        const p = new Proxy(data, handle)
        const proxyData = Object.assign({}, p)
        return proxyData
      } else {
        const proxyData = {}
        for (const key in data) {
          proxyData[key] = handle.get(data, key)
        }
        return proxyData
      }
    },
    // 准备查询数据
    loadData() {
      console.log(`回车查询`)
      if (this.$refs['form']) {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.queryParams.sendStatus = this.state
            if (this.data && this.data.length > 0) {
              this.data = []
            }
            this.loadTableData(this.exchangeData(this.queryParams))
          }
        })
      } else {
        this.queryParams.sendStatus = this.state
        if (this.data && this.data.length > 0) {
          this.data = []
        }
        this.loadTableData(this.exchangeData(this.queryParams))
      }
    },
    // 加载货源数据
    loadTableData(params) {
      this.viewManager.loading = true
      getPageList(this.pagination, params)
        .then(data => {
          if (data.result.rows && data.result.rows.length > 0) {
            this.data = data.result.rows.map(item => {
              if (!item.hasOwnProperty('hidden')) {
                item.hidden = true
              }
              if (!item.hasOwnProperty('selection')) {
                item.selection = false
              }
              if (item.fileUrl !== '') {
                item.fileUrl = String(item.fileUrl).split(',')
              }
              return item
            })
          }
          this.pagination.total = data.result.total || this.data.length
        })
        .catch(error => {
          this.data = goodsListData.map(item => {
            if (!item.hasOwnProperty('hidden')) {
              item.hidden = true
            }
            return item
          })
          this.pagination.total = this.data.length
          console.error(error)
        })
        .finally(() => {
          // 数据刷新时  全选状态为false
          this.allSelection = false
          this.scrollTop()
          this.viewManager.loading = false
        })
    },
    // 删除货源
    del(id) {
      this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (id) {
            del({ id: id })
              .then(data => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.loadData()
              })
              .catch(error => {
                console.error(error)
              })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //  下架货源
    revoke(item) {
      if (item.numberInvitation > 0) {
        this.$message({
          type: 'warning',
          message: '已邀请报价，不得取消发布!'
        })
        return false
      }
      if (item.numberQuotation > 0) {
        this.$message({
          type: 'warning',
          message: '已进入报价，不得取消发布!'
        })
        return false
      }
      this.$confirm('此操作将下架这条货源数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (item.id) {
            revoke({ ids: item.id, sendStatus: State.UNPUBLISH })
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '下架成功!'
                })
                this.loadData()
              })
              .catch(error => {
                console.error(error)
              })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下架'
          })
        })
    },
    // 编辑货源
    edit(id) {
      this.$router.push({ path: './publish-goods', query: { goodsId: id }})
    },
    // 批量发布货源
    batchPublishGoods() {
      let items = this.data.filter(item => item.selection)
      if (items.length > 0) {
        items = items.filter((item, index) => {
          const result = validateData(item)
          if (result && !result.state) {
            this.$message({
              type: 'error',
              message: `所选第${parseInt(index) + 1}条数据不完整，请先填写完整再发布!`
            })
            return false
          }
          return true
        }).map(i => i.id)
        if (items.length == 0) return false
        batchIssue({ ids: items.toString(), sendStatus: State.PUBLISH })
          .then(data => {
            this.$message({
              type: 'success',
              message: '发布成功!'
            })
            this.loadData()
          })
          .catch(error => {
            console.error(error)
          })
      } else {
        this.$message({
          type: 'warning',
          message: '请选择要发布的数据!'
        })
      }
    },
    // 发布货源
    publishGoods(item) {
      const result = validateData(item)
      if (result && !result.state) {
        this.$message({
          type: 'error',
          message: `数据不完整，请先填写完整再发布!`
        })
        return false
      }
      batchIssue({ ids: item.id, sendStatus: State.PUBLISH })
        .then(data => {
          this.$message({
            type: 'success',
            message: '发布成功!'
          })
          this.loadData()
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";

$main-color: #be2316;
.goods-name.el-input {
  width: 211px;
}

.content-container {
  box-sizing: border-box;
  margin-top: 1px;
  .goods-head {
    padding: 12px 12px;
    box-sizing: border-box;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    height: 189px;

    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;

        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .goods-head-form {
      /deep/ [class^="el-icon-"] {
        margin-right: 0.5rem;
      }
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: " : ";
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .operations {
    /deep/ [class^="el-icon-"] {
      margin-right: 0.5rem;
    }
    margin: 16px 0px;
  }

  .goods-data {
    .goods-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 51px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
      border-radius: 4px;
      // margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        line-height: 51px;
        // width: calc(100% - 16px);
        // padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 14px;
          min-width: 50px;
          // height: 100%;
          // line-height: 29px;
          margin: auto auto;
          text-align: center;
          &:first-child.check {
            flex-basis: 5%;
          }

          &:first-child.publish {
            flex-basis: 25%;
          }
          &:nth-child(2) {
            flex-basis: 23%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 8%;
          }
          &:nth-child(6) {
            flex-basis: 8%;
          }
          &:nth-child(7) {
            flex-basis: 8%;
          }
          &:nth-child(8) {
            flex-basis: 8%;
          }
          &:last-child {
            flex-basis: 140px !important;
          }
        }
      }
    }

    .goods-data-body {
      position: relative;
      // min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }
      .data-item {
        // height: 83px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
        border-radius: 4px;
        margin: 8px 0px;
        // border: 1px solid #ebeef5;
        position: relative;
        box-sizing: border-box;

        ul {
          display: flex;
          flex-wrap: nowrap;
          width: 100%;
          min-height: 83px;
          position: relative;
          background-color: white;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);

          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            > div.vertical-align {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              width: 100%;
              position: relative;
            }
            margin: auto;
            padding: 0px 4px;

            text-align: center;
            position: relative;
            &:first-child.check {
              flex-basis: 5%;
            }
            &:first-child.publish {
              flex-basis: 25%;
            }
            &:nth-child(2) {
              flex-basis: 23%;
              color: #333;
            }
            &:nth-child(3) {
              flex-basis: 10%;
              color: #333;
            }
            &:nth-child(4) {
              flex-basis: 10%;
              color: #555;
            }
            &:nth-child(5) {
              flex-basis: 8%;
              // color: #2e6fda;
            }
            &:nth-child(6) {
              flex-basis: 8%;
              // color: #2e6fda;
            }
            &:nth-child(7) {
              flex-basis: 8%;
              // color: #2e6fda;
            }
            &:nth-child(8) {
              flex-basis: 8%;
              // color: #2e6fda;
            }
            &:last-child {
              flex-basis: 140px !important;
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(5) {
                color: black !important;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 0.5s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .goods-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .goods-data-pagination {
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .recommend-dialog-head {
    box-sizing: border-box;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;

        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .goods-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: " : ";
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
